import { writable, get } from "svelte/store";
import sounds from "./sounds";
import { victories } from "./texts";

const gameState = writable({
  currentPage: "GAME_MENU_PAGE",
  levelNumber: null,
  levelProps: {},
  regenerateLevel: true,

  totalTime: 60,
  timeLeft: 0,
  progressBarValue: 100,

  soundsReady: false,
  score: 0,
  maxScore: 0,
});

function resetGame() {
  gameState.update((state) => ({
    currentPage: "GAME_MENU_PAGE",
    levelNumber: null,
    levelProps: {},
    regenerateLevel: true,

    totalTime: 60,
    timeLeft: 0,
    progressBarValue: 100,

    soundsReady: true,
    score: 0,
    maxScore: 0,
  }));
}

function switchPage(currentPage) {
  gameState.update((state) => {
    const soundName = state.levelProps.backgroundSoundKey;

    if (soundName) {
      sounds[soundName].player.pause();
    }

    return {
      ...state,
      currentPage,
    };
  });
}

function pause() {
  gameState.update((state) => {
    const soundName = state.levelProps.backgroundSoundKey;

    if (soundName) {
      sounds[soundName].player.pause();
    }

    return {
      ...state,
      currentPage: "GAME_PAUSE",
      isNewGame: false,
    };
  });
}

function resumeGame() {
  gameState.update((state) => {
    const soundName = state.levelProps.backgroundSoundKey;
    sounds[soundName].player.play();

    return {
      ...state,
      currentPage: "GAME_PAGE",
      regenerateLevel: true,
    };
  });
}

function newGame() {
  gameState.update((state) => {
    const soundName = state.levelProps.backgroundSoundKey;
    sounds[soundName].player.currentTime = 0;
    sounds[soundName].player.play();

    return {
      ...state,
      currentPage: "GAME_PAGE",
      regenerateLevel: true,
    };
  });
}

function victory() {
  gameState.update((state) => {
    const soundName = state.levelProps.backgroundSoundKey;

    if (soundName) {
      sounds[soundName].player.pause();
    }

    sounds.victory.player.play();

    return {
      ...state,
      currentPage: "GAME_END",
      isNewGame: true,
      isVictory: true,
    };
  });
}

function timeIsUp() {
  gameState.update((state) => {
    const soundName = state.levelProps.backgroundSoundKey;
    sounds[soundName].player.pause();
    sounds.defeat.player.play();

    return {
      ...state,
      currentPage: "GAME_END",
      isNewGame: true,
      isVictory: false,
    };
  });
}

function defeat() {
  gameState.update((state) => {
    const soundName = state.levelProps.backgroundSoundKey;
    sounds[soundName].player.pause();
    sounds.defeat.player.play();

    return {
      ...state,
      currentPage: "GAME_END",
      regenerateLevel: true,
      isVictory: false,
    };
  });
}

function gameTick(newValues) {
  gameState.update((state) => ({
    ...state,
    ...newValues,
  }));
}

function tap(props) {
  sounds.tap.player.play();

  if (props.isBad) {
    return defeat();
  }

  gameState.update((state) => {
    let returnValue = {};

    const score = state.score + state.levelProps.tapValue;

    if (score >= state.maxScore) {
      const soundName = state.levelProps.backgroundSoundKey;

      if (soundName) {
        sounds[soundName].player.pause();
      }

      sounds.victory.player.play();

      return {
        ...state,
        score,
        currentPage: "GAME_END",
        isNewGame: true,
        isVictory: true,
      };
    }

    return {
      ...state,
      score,
      regenerateLevel: true,
    };
  });
}

function gameResoursesLoaded() {
  gameState.update((state) => ({
    ...state,
    soundsReady: true,
  }));
}

export {
  tap,
  gameState,
  switchPage,
  get,
  pause,
  newGame,
  timeIsUp,
  gameTick,
  resumeGame,
  gameResoursesLoaded,
  resetGame,
};
